var React = require('react');

function Cell (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"className":"stroke-border fill-none","style":{"transition":"fill 0.3s ease-out"},"points":"32.6,0.5 11.3,0.5 0.6,19 11.3,37.5 32.6,37.5 43.3,19"}));
}

Cell.defaultProps = {"version":"1.0","width":"44px","height":"38px","viewBox":"0 0 44 38","xmlSpace":"preserve"};

module.exports = Cell;

Cell.default = Cell;
